import { useGlobalModal } from '@/hooks/useGlobalModal';
import GlobalModal from '@components/GlobalModal';
import { Access } from '@features/authorization';
import { type FC } from 'react';
import { PanelChart } from './PanelChart';
import { PanelNotifications } from './PanelNotifications';
import { PanelOperation } from './PanelOperation';
import { PanelStatus } from './PanelStatus';
import { PanelSummary } from './PanelSummary';
import { PanelTitle } from './PanelTitle';

export const GateOperationModal: FC = () => {
  const { globalModalProps, state, onClose } = useGlobalModal('gateOperationModal');

  const movementId = state.open ? state.movementId : null;

  return (
    <GlobalModal
      {...globalModalProps}
      authorization={{ access: Access.Allow }}
      dialogProps={{
        maxWidth: 'lg',
        PaperProps: {
          sx: {
            p: 2,
            height: '100%',
            display: 'grid',
            gap: 1,
            gridTemplateRows: 'auto auto 1fr 240px',
            gridTemplateColumns: '250px 1fr auto',
            gridTemplateAreas: `
"title title status"
"summary operation operation"
"summary notif notif"
"chart notif notif"
`,
          },
        },
      }}
    >
      {/* TODO(AMARU-866): reactivar TelemetrySubscriber con el subscription manager on-demand. */}
      <PanelTitle movementId={movementId} onClose={onClose} />
      <PanelStatus movementId={movementId} />
      <PanelSummary movementId={movementId} />
      <PanelChart movementId={movementId} />
      <PanelOperation movementId={movementId} />
      <PanelNotifications movementId={movementId} />
    </GlobalModal>
  );
};
